<template>
  <section>
    <base-card>
      <h2>Register as a coach now</h2>
      <!-- poslušamo save-data event emittan iz CoachForm komponente in ga zajamemo v saveData methods:  -->
      <coach-form @save-data="saveData"></coach-form>
    </base-card>
  </section>
</template>

<script>
import CoachForm from '@/components/coaches/CoachForm.vue';
export default {
  components: {
    CoachForm,
  },
  methods: {
    // data value nosi emittan event.
    // saveData komunicira z mutations.js v coaches
    saveData(data) {
      // dispatchamo action iz actions.js   namespace/action name , data iz actions (context, data)
      this.$store.dispatch('coaches/registerCoach', data);
      // da nas ob pritisku na register (ki sproži saveData) preusmeri nazaj na /coaches
      //   this.$router.push('/coaches')

      // če uporabimo .replace je razlika da ne moremo nazaj na prejšno stran
      this.$router.replace('/coaches');
    },
  },
};
</script>
